<template>
  <div class="vipupApply" v-wechat-title="title">
    <ul>
      <li>
        <p class="f15 must">姓名</p>
        <!-- 输入任意文本 -->
        <van-field
          v-model="info.name"
          :class="{ error_field: err_msg.name }"
          :error-message="err_msg.name"
          maxlength="20"
          placeholder="请输入姓名"
          center
          label=""
        />
      </li>
      <li>
        <p class="f15 must">注册电话</p>
        <!-- 输入手机号，调起手机号键盘 -->
        <van-field
          v-model="info.mobile"
          :class="{ error_field: err_msg.mobile }"
          :error-message="err_msg.mobile"
          maxlength="11"
          center
          type="tel"
          placeholder="请输入手机号码"
          label=""
        />
        <van-field
          v-model="info.imgsms"
          :class="{ error_field: err_msg.imgsms }"
          :error-message="err_msg.imgsms"
          maxlength="4"
          center
          label=""
          placeholder="请输入图片验证码"
        >
          <template #button>
            <img class="codeImg" ref="codeImg" :src="codeImg" @click="getCodeImg" alt="" />
          </template>
        </van-field>
        <van-field
          v-model="info.sms"
          :class="{ error_field: err_msg.sms }"
          :error-message="err_msg.sms"
          maxlength="6"
          type="digit"
          center
          label=""
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              class="sms"
              v-if="time == 0"
              @click="getCodeMessage"
              size="small"
              type="primary"
              color="linear-gradient( 90deg, #FC0324 0%, #F63A66 100%)"
            >
              获取验证码
            </van-button>
            <van-button
              class="sms gray_sms"
              v-else
              size="small"
              plain
              type="primary"
              color="#DCDCDC"
            >
              {{ `${time}s` }}
            </van-button>
          </template>
        </van-field>
      </li>
      <li>
        <p class="f15">身份证号码</p>
        <!-- 输入任意文本 -->
        <van-field
          v-model="info.idcard"
          :class="{ error_field: err_msg.idcard }"
          :error-message="err_msg.idcard"
          placeholder="请输入身份证号码"
          maxlength="18"
          center
          label=""
        />
      </li>
      <li>
        <p class="f15 must">收件地址</p>
        <!-- 输入任意文本 -->
        <van-field
          class="addres_select"
          v-model="info.area"
          :error-message="err_msg.area"
          :class="{ error_field: err_msg.area }"
          readonly
          right-icon="arrow"
          @click="regionClick"
          placeholder="请选择省/市/区"
          center
          label=""
        />
        <van-field
          v-model="info.address"
          :class="{ error_field: err_msg.address }"
          :error-message="err_msg.address"
          maxlength="200"
          rows="3"
          label=""
          type="textarea"
          placeholder="请输入详细地址"
          :autosize="{ minHeight: 40 }"
        />
      </li>
    </ul>
    <div class="h"></div>
    <footer class="footerIOS">
      <button class="btn" @click="submit">提交</button>
    </footer>

    <awesome-picker
      v-if="regionShow"
      ref="pickerRegion"
      :textTitle="pickerRegion.textTitle"
      :data="pickerRegion.data"
      :anchor="pickerRegion.anchor"
      @confirm="handlePickerConfirmRegion"
    ></awesome-picker>

    <van-overlay :show="qrcodeShow" z-index="2001">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="radius-8px pb15 pt0 pl0 pr0 bg-F">
            <img :src="qrcode" alt="" />
            <p class="f15 color-3 mt15 ml30 mr30">完善信息成功，扫码免费升级</p>
            <p class="f13 color-6 mt8 ml30 mr30">
              保存二维码图片，扫码添加运营人员，锁定免费升级名额
            </p>
            <van-button
              class="mt15 f15"
              style="height: 0.38rem; width: 1.63rem"
              type="primary"
              round
              color="linear-gradient( 91deg, #FC0324 0%, #F63A66 100%)"
              @click="knowHandle"
            >
              我知道了
            </van-button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import Vue from 'vue';
import { isWeixin, fenxiang, random_string } from '../../assets/common/js/config'
// import wx from "weixin-js-sdk";

export default {
  name: 'vipupApply',
  data() {
    return {
      info: {
        name: '',
        mobile: '',
        imgsms: '',
        sms: '',
        idcard: '',
        area: '',
        areaid: '',
        address: ''
      },
      err_msg: {
        name: '',
        mobile: '',
        imgsms: '',
        sms: '',
        idcard: '',
        area: '',
        address: ''
      },
      time: 0,
      codeImg: null, // 图片验证码
      timeout: null, // 事件随机码
      pickerRegion: {
        anchor: [],
        textTitle: '区域选择器',
        data: []
      },
      regionShow: true,
      title: '',
      qrcodeShow: false,
      qrcode: ''
    }
  },
  watch: {
    'info.name': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.name = '请输入'
        } else {
          this.err_msg.name = ''
        }
      }
    },
    'info.mobile': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.mobile = '请输入'
        } else {
          this.err_msg.mobile = ''
        }
      }
    },
    'info.imgsms': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.imgsms = '请输入'
        } else {
          this.err_msg.imgsms = ''
        }
      }
    },
    'info.sms': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.sms = '请输入'
        } else {
          this.err_msg.sms = ''
        }
      }
    },
    'info.idcard': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.idcard = ''
        } else {
          this.err_msg.idcard = ''
        }
      }
    },
    'info.area': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.area = '请选择'
        } else {
          this.err_msg.area = ''
        }
      }
    },
    'info.address': {
      handler(newVal) {
        if (!newVal.trim()) {
          this.err_msg.address = '请输入'
        } else {
          this.err_msg.address = ''
        }
      }
    }
  },
  beforeMount() {
    if (this.$route.query.upgrade == 1) {
      this.title = '完善信息'
    } else {
      this.title = '申请成为50VIP'
    }
  },
  mounted() {
    this.$app.argFunc(() => {
      if (isWeixin()) {
        fenxiang({ path: 'vipupApply' })
      }
    })
    this.getData()
  },
  methods: {
    getData() {
      this.getCodeImg()
      var url = this.$ajax.getArea_URL
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.pickerRegion.data = res.data.data
          that.pickerRegion.data.forEach((item) => {
            item['value'] = item.name
            delete item['name']
            item['children'] = item.child
            delete item['child']
            item.children.forEach((itemSon) => {
              itemSon['province'] = item.value
              itemSon['value'] = itemSon.name
              delete itemSon['name']
              itemSon['children'] = itemSon.child
              delete itemSon['child']
              itemSon.children.forEach((itemGrandson) => {
                itemGrandson['value'] = itemGrandson.name
                delete itemGrandson['name']
                itemGrandson['city'] = itemSon.value
              })
            })
          })
          that.pickerRegion.data = res.data.data
        }
      })
    },
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    getCodeMessage() {
      if (this.info.mobile == '') {
        this.$toast('手机号码不能为空')
        return
      } else if (!/^1[3456789]\d{9}$/.test(this.info.mobile)) {
        this.$toast('手机号码输入有误')
        return
      } else if (this.info.imgsms == '') {
        this.$toast('验证码不能为空')
        return
      } else if (this.info.imgsms.length < 4) {
        this.$toast('验证码输入有误')
        return
      }

      let that, url

      that = this
      url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.info.mobile +
        '&code=' +
        this.info.imgsms +
        '&sessionid=' +
        this.timeout +
        '&type=3' +
        '&area_code=86'

      that.$toast.loading({
        mask: false,
        message: '发送中...',
        duration: 0,
        forbidClick: true
      })
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.$toast({
            message: '发送成功',
            icon: require('../../assets/images/succ.png')
          })
          that.time = 60
          that.countdown()
        } else if (res.data.code == '10011') {
          that.info.imgsms = ''
          that.getCodeImg()
        }
      })
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          if (!that.imgCodeWrapFlag) {
            that.imgCodeWrapFlag = true
          }
          clearInterval(timer)
        }
      }, 1000)
    },
    regionClick: function () {
      if (this.pickerRegion.data.length > 0) {
        setTimeout(() => {
          this.$refs.pickerRegion.show()
        })
      } else {
        this.$toast('当前网络环境较差，请稍后再试')
      }
    },
    handlePickerConfirmRegion(v) {
      this.pickerRegion.anchor = v
      var that = this
      that.info.areaid =
        that.pickerRegion.data[v[0].index].id +
        ',' +
        that.pickerRegion.data[v[0].index].children[v[1].index].id +
        ',' +
        that.pickerRegion.data[v[0].index].children[v[1].index].children[v[2].index].id
      that.info.area = ''
      v.forEach(function (item, idx) {
        that.info.area = that.info.area == '' ? item.value : that.info.area + ' ' + item.value
      })
    },
    submit() {
      try {
        let iserr = 0
        Object.keys(this.info).forEach((key) => {
          if (this.info[key].trim() == '' && key != 'idcard') {
            this.$toast(
              `请${key == 'area' ? '选择' : '输入'}${
                key == 'name'
                  ? '姓名'
                  : key == 'mobile'
                  ? '手机号'
                  : key == 'imgsms'
                  ? '图片验证码'
                  : key == 'sms'
                  ? '短信验证码'
                  : key == 'idcard'
                  ? ''
                  : key == 'area'
                  ? '地区'
                  : '地址'
              }`
            )
            throw new Error('不能为空')
          } else if (this.info[key].trim() != '') {
            if (key == 'mobile' && !/^1[3456789]\d{9}$/.test(this.info[key].trim())) {
              iserr = 1
              this.err_msg[key] = '手机号不正确'
            } else if (key == 'imgsms' && !/^(?:\d+|[a-zA-Z]+){4}$/.test(this.info[key].trim())) {
              iserr = 1
              this.err_msg[key] = '图片验证码不正确'
            } else if (key == 'sms' && !/^\d{6}$/.test(this.info[key].trim())) {
              iserr = 1
              this.err_msg[key] = '短信验证码不正确'
            } else if (key == 'idcard' && !/^\d{17}(\d|x)$/i.test(this.info[key].trim())) {
              iserr = 1
              this.err_msg[key] = '身份证号码不正确'
            }
          }
        })
        if (iserr == 1) {
          this.$toast('输入格式不正确，请检查')
          throw new Error('格式不正确')
        }
        var paramsData = {
          name: this.info.name.trim(),
          mobile: this.info.mobile.trim(),
          code: this.info.sms.trim(),
          idcard: this.info.idcard.trim(),
          areaid: this.info.areaid.trim(),
          area: this.info.area.trim(),
          address: this.info.address.trim()
        }
        let url = this.$ajax.upgrade_URL
        if (this.$route.query.upgrade == 1) {
          url = this.$ajax.saveUpgradeData_URL
        }
        this.$customRequestAjax.post(url, paramsData).then((res) => {
          if (res.data.code == 200) {
            if (this.$route.query.upgrade == 1) {
              if (res.data.qrcode) {
                this.qrcode = res.data.qrcode
                this.qrcodeShow = true
              } else {
                this.knowHandle()
              }
            } else {
              this.$app.argLink({ path: '/vipupsucc' })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    knowHandle() {
      history.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/footerSubmit';
.h {
  height: 0.93rem;
}
</style>
<style lang="scss">
.vipupApply > ul {
  background-color: #fff;
  margin: 0.1rem 0.11rem;
  border-radius: 0.1rem;
  padding: 0.1rem 0.16rem 0.2rem;
  li {
    > p {
      margin: 0.1rem 0;
      &.must::before {
        content: '*';
        color: #fc0324;
        font-size: 0.15rem;
      }
    }
    .van-cell::after {
      display: none;
    }
    .van-field {
      padding: 0;
      margin-bottom: 0.05rem;
      &.error_field {
        &.addres_select {
          .van-field__value {
            .van-field__body {
              border-color: #fc0324;
            }
            .van-field__control {
              border-color: transparent;
            }
          }
        }
        .van-field__value {
          .van-field__control {
            border-color: #fc0324;
          }
        }
      }
      &.addres_select {
        .van-field__value {
          .van-field__body {
            height: 0.37rem;
            border: 0.01rem solid #e6e6e6;
            border-radius: 0.06rem;
            padding: 0.08rem 0.1rem;
          }
          .van-field__control {
            border-color: transparent;
            border-radius: 0.06rem;
            padding: 0;
          }
        }
      }
      .van-field__value {
        // position: relative;
        min-height: 0.55rem;
        .van-field__control {
          height: 0.37rem;
          border: 0.01rem solid #e6e6e6;
          border-radius: 0.06rem;
          padding: 0.08rem 0.1rem;
        }
        .van-field__error-message {
          font-size: 0.1rem;
          margin-left: 0.1rem;
          transform-origin: left top;
          transform: scale(0.8);
          height: 0.15rem;
        }
      }
    }
  }
  .codeImg {
    width: 0.85rem;
    height: 0.37rem;
    border-radius: 0.06rem;
    border: 0.01rem solid rgba(0, 0, 0, 0.1);
  }
  .sms {
    width: 0.85rem;
    &.gray_sms {
      background-color: #f5f5f5;
      .van-button__content {
        color: #5f5f5f;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upgradeVIP/vipupApply.vue